export default "__VITE_ASSET__B9WS5vKz__"